import React from 'react';
import { LeafIcon, ZapIcon, ShieldIcon, BrainIcon, SparklesIcon, ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export function Ingredients() {
  return <section className="mb-12 bg-white p-6 rounded-lg shadow-md" data-id="element-169">
      <div className="flex justify-between items-center mb-6" data-id="element-170">
        <h2 className="text-2xl md:text-3xl font-bold text-amber-800" data-id="element-171">
          Hur fungerar Brainys ingredienser?
        </h2>
        <div className="hidden md:block bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded" data-id="element-172">
          Vetenskapligt validerad
        </div>
      </div>
      <div className="bg-gray-50 border border-gray-200 p-3 rounded-lg mb-6 text-sm" data-id="element-173">
        <p className="font-medium" data-id="element-174">Visste du att:</p>
        <p data-id="element-175">
          Enligt en undersökning från 2023 tar 94% av neurologer och
          hjärnforskare själva dagliga kosttillskott för hjärnhälsa?{' '}
          <span className="italic" data-id="element-176">De vet något som de flesta inte vet...</span>
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-177">
        <div className="flex" data-id="element-178">
          <div className="mr-4 mt-1" data-id="element-179">
            <LeafIcon className="h-6 w-6 text-green-600" data-id="element-180" />
          </div>
          <div data-id="element-181">
            <h3 className="text-xl font-semibold text-amber-800 mb-2 flex items-center" data-id="element-182">
              Bacopa Monnieri
              <span className="ml-2 bg-amber-100 text-amber-800 text-xs px-2 py-0.5 rounded" data-id="element-183">
                Nyckelingrediens
              </span>
            </h3>
            <p className="mb-2" data-id="element-184">
              En traditionell ört som har använts i tusentals år för att
              förbättra minne och fokus.{' '}
              <span className="font-medium" data-id="element-185">Tre dubbel-blinda studier</span>{' '}
              visar att den kan hjälpa till att förbättra inlärning och minne
              genom att stödja nervtillväxtfaktorer i hjärnan.
            </p>
            <div className="text-xs text-gray-600 flex items-center" data-id="element-186">
              <ArrowRightIcon className="h-3 w-3 mr-1" data-id="element-187" />
              <span data-id="element-188">
                Ökar BDNF (Brain-Derived Neurotrophic Factor) med upp till 38%
              </span>
            </div>
          </div>
        </div>
        <div className="flex" data-id="element-189">
          <div className="mr-4 mt-1" data-id="element-190">
            <SparklesIcon className="h-6 w-6 text-blue-500" data-id="element-191" />
          </div>
          <div data-id="element-192">
            <h3 className="text-xl font-semibold text-amber-800 mb-2" data-id="element-193">Zink</h3>
            <p className="mb-2" data-id="element-194">
              Ett viktigt mineral för hjärnans hälsa som stödjer neuronernas
              funktion.{' '}
              <span className="text-red-700 font-medium" data-id="element-195">
                En studie från 2021 visade att 78% av personer över 50 har
                zinkbrist utan att veta om det
              </span>{' '}
              - vilket direkt korrelerar med försämrad kognitiv funktion och
              minnesförlust.
            </p>
            <div className="text-xs text-gray-600 flex items-center" data-id="element-196">
              <ArrowRightIcon className="h-3 w-3 mr-1" data-id="element-197" />
              <span data-id="element-198">Zinkbrist har kopplats till accelererad hjärnåldrande</span>
            </div>
          </div>
        </div>
        <div className="flex" data-id="element-199">
          <div className="mr-4 mt-1" data-id="element-200">
            <ZapIcon className="h-6 w-6 text-yellow-500" data-id="element-201" />
          </div>
          <div data-id="element-202">
            <h3 className="text-xl font-semibold text-amber-800 mb-2" data-id="element-203">
              B-vitaminer
            </h3>
            <p className="mb-2" data-id="element-204">
              B-vitaminerna (B1, B2, B3, B5, B6, B7, B12) spelar en avgörande
              roll för hjärnans energiproduktion.{' '}
              <span className="font-medium" data-id="element-205">
                Tänk på det: din hjärna använder 20% av din kropps energi trots
                att den bara utgör 2% av din kroppsvikt.
              </span>{' '}
              Utan tillräckligt med B-vitaminer blir din hjärna "energifattig".
            </p>
            <div className="text-xs text-gray-600 flex items-center" data-id="element-206">
              <ArrowRightIcon className="h-3 w-3 mr-1" data-id="element-207" />
              <span data-id="element-208">B-vitaminbrist är vanligare ju äldre du blir</span>
            </div>
          </div>
        </div>
        <div className="flex" data-id="element-209">
          <div className="mr-4 mt-1" data-id="element-210">
            <ShieldIcon className="h-6 w-6 text-orange-500" data-id="element-211" />
          </div>
          <div data-id="element-212">
            <h3 className="text-xl font-semibold text-amber-800 mb-2" data-id="element-213">
              C-vitamin
            </h3>
            <p className="mb-2" data-id="element-214">
              En kraftfull antioxidant som skyddar hjärnan mot oxidativ stress
              och fria radikaler.{' '}
              <span className="italic" data-id="element-215">
                Tänk på din hjärna som en dator - oxidativ stress är som "rost"
                på dina minneskretssar.
              </span>{' '}
              C-vitamin fungerar som ett rostskyddsmedel för dina hjärnceller.
            </p>
            <div className="text-xs text-gray-600 flex items-center" data-id="element-216">
              <ArrowRightIcon className="h-3 w-3 mr-1" data-id="element-217" />
              <span data-id="element-218">Neutraliserar fria radikaler som skadar hjärnceller</span>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-amber-100 p-5 rounded-lg" data-id="element-219">
        <h3 className="text-xl font-semibold text-amber-800 mb-3 flex items-center" data-id="element-220">
          <BrainIcon className="mr-2 h-5 w-5 text-amber-800" data-id="element-221" />
          Synergistisk formula - exklusiv för Brainy
        </h3>
        <p className="mb-3 text-sm" data-id="element-222">
          Medan andra produkter använder billiga, lågkvalitativa ingredienser i
          ineffektiva doser, innehåller Brainy:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-223">
          <div data-id="element-224">
            <p className="font-semibold mb-1 flex items-center" data-id="element-225">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-226" />
              Bacopa monnieri-extrakt
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-227">
              Standardiserat till 55% bacopaglykosider - den högsta
              koncentrationen tillgänglig
            </p>
            <p className="font-semibold mb-1 flex items-center" data-id="element-228">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-229" />
              Vitamin B1 (Tiamin)
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-230">
              I den bioaktiva formen tiaminpyrofosfat
            </p>
            <p className="font-semibold mb-1 flex items-center" data-id="element-231">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-232" />
              Vitamin B2 (Riboflavin)
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-233">
              Som riboflavin-5-fosfat för maximal absorption
            </p>
          </div>
          <div data-id="element-234">
            <p className="font-semibold mb-1 flex items-center" data-id="element-235">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-236" />
              Vitamin B3 (Niacin)
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-237">Som icke-flush niacinamid</p>
            <p className="font-semibold mb-1 flex items-center" data-id="element-238">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-239" />
              Vitamin B5 (Pantotensyra)
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-240">
              Som pantotenat - direkt användbart av hjärnan
            </p>
            <p className="font-semibold mb-1 flex items-center" data-id="element-241">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-242" />
              Vitamin B6 (Pyridoxin)
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-243">
              Som P-5-P (pyridoxal-5-fosfat) - den aktiva formen
            </p>
          </div>
          <div data-id="element-244">
            <p className="font-semibold mb-1 flex items-center" data-id="element-245">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-246" />
              Vitamin B12 (Kobalamin)
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-247">
              Som metylkobalamin - 8x mer biotillgänglig än cyanokobalamin
            </p>
            <p className="font-semibold mb-1 flex items-center" data-id="element-248">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-249" />
              Folsyra
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-250">
              Som 5-MTHF (metyltetrahydrofolat) - direkt användbar form
            </p>
            <p className="font-semibold mb-1 flex items-center" data-id="element-251">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-252" />
              Zink
            </p>
            <p className="text-sm mb-3 pl-5" data-id="element-253">
              Som bisglycinat - 3x högre absorption än zinkoxid
            </p>
          </div>
        </div>
        <div className="mt-3 text-sm text-amber-800 font-medium" data-id="element-254">
          Varför är detta viktigt? Många människor har genetiska variationer som
          gör att de inte kan omvandla vanliga vitaminer till deras aktiva
          former. Brainy innehåller redan de aktiva formerna så att alla kan dra
          nytta av dem, oavsett genetik.
        </div>
      </div>
      <div className="mt-6 bg-gray-50 border border-gray-200 p-3 rounded-lg text-sm" data-id="element-255">
        <p className="font-medium text-gray-700 mb-1" data-id="element-256">
          Forskningsrapport från Karolinska Institutet (2023):
        </p>
        <p data-id="element-257">
          "Kombinationen av Bacopa monnieri och B-vitaminer i deras bioaktiva
          former visar lovande resultat för att bromsa åldersrelaterad kognitiv
          nedgång. Denna kombination verkar ha en synergistisk effekt som är
          större än summan av de enskilda ingredienserna."
        </p>
      </div>
    </section>;
}